
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "10 conseils pour optimiser le ROI de vos campagnes Google Ads !",
    description:
      "Optimisez vos campagnes Google Ads pour maximiser votre retour sur investissement. Suivez nos conseils pour améliorer vos performances et augmenter vos conversions.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
